import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { connect } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import * as actions_stock from "redux/actions/stockActions";
import * as actions_event from "redux/actions/eventActions";
import ListStockSelect from 'components/ListStockSelect';
import { Translate } from "react-redux-i18n";
import InputDate from 'components/InputDate';

const schema = {
    symbol: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 300
        }
    },
    market: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 50
        }
    },
    option_kind: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 50
        }
    },
}

const FormDialog = (props) => {
    // const { className, history, ...rest } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setDialogState({
            isValid: false,
            values: {
                quantity: 1,
                open_price: 0.01,
                strike: 1,
                open_at: new Date().toISOString().split('T')[0],
                expire_at: new Date().toISOString().split('T')[0],
                id: props.user_id,
                share: false,
                name: "",
                symbol: "",
                reference: "",
                option_kind: "",
                market: ""
            },
            touched: {},
            errors: {}
        });
    };

    const handleClose = () => {
        setOpen(false);
        props.resetList();
    };

    const handleSave = async (event) => {
        event.preventDefault();
        if (dialogState.values.symbol === "") {

            return;
        }
        await props.newItem(dialogState.values, props.token);
        await props.loadList(props.user_id, props.token);
        props.suscribeOption(dialogState.values);
        setOpen(false);
    };

    const handleSaveShare = async (event) => {
        event.preventDefault();
        if (dialogState.values.symbol === "") {

            return;
        }
        await props.newItem({ ...dialogState.values, share: true }, props.token);
        await props.loadList(props.user_id, props.token);
        props.suscribeOption(dialogState.values);
        setOpen(false);
    };

    const [dialogState, setDialogState] = useState({
        isValid: false,
        values: {
            quantity: 1,
            open_price: 0.01,
            strike: 1,
            open_at: new Date().toISOString().split('T')[0],
            expire_at: new Date().toISOString().split('T')[0],
            id: props.user_id,
            share: false,
            name: "",
            symbol: "",
            reference: "",
            option_kind: "",
            market: ""
        },
        touched: {},
        errors: {}
    });

    useEffect(() => {
        const errors = validate(dialogState.values, schema);
        setDialogState(dialogState => ({
            ...dialogState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [dialogState.values]);

    const handleChange = event => {
        event.persist();
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                [event.target.name]: event.target.value
            },
            touched: {
                ...dialogState.touched,
                [event.target.name]: true
            }
        }));
    };

    const handleChangeSymbol = (event) => {
        event.persist();
        if (event.target.value.trim() !== dialogState.values.symbol) {
            setDialogState(dialogState => ({
                ...dialogState,
                values: {
                    ...dialogState.values,
                    [event.target.name]: event.target.value.trim(),
                    name: ""
                },
                touched: {
                    ...dialogState.touched,
                    [event.target.name]: true
                }
            }));
            props.searchList({ id: props.user_id, search: event.target.value }, props.token);
        }
        else props.resetList();
    };

    const option_kind = [
        {
            value: "CALL",
            label: "Call",
        },
        {
            value: "PUT",
            label: "Put",
        },
    ];

    const option_market = [
        {
            value: "SELL",
            label: "STO",
        },
        {
            value: "BUY",
            label: "BTO",
        },
    ];

    const onClickSelected = (item) => {
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                symbol: item.symbol,
                name: item.name
            },
        }));
        props.resetList();
    };

    const handleChangeStrategy = (event) => {
        event.persist();

        switch (event.target.value) {
            case "CoveredCall":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        [event.target.name]: event.target.value,
                        market: "SELL",
                        option_kind: "CALL"
                    },
                }));
                break;

            case "CoveredPut":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        [event.target.name]: event.target.value,
                        market: "SELL",
                        option_kind: "PUT"
                    },
                }));
                break;

            case "NakedCall":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        [event.target.name]: event.target.value,
                        market: "SELL",
                        option_kind: "CALL"
                    },
                }));
                break;

            case "NakedPut":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        [event.target.name]: event.target.value,
                        market: "SELL",
                        option_kind: "PUT"
                    },
                }));
                break;
            default: {
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        [event.target.name]: event.target.value,
                    },
                }));
            } break;
        };
    }

    const option_strategy =
        [
            {
                value: "CoveredCall",
                label: "CoveredCall",
            },
            {
                value: "CoveredPut",
                label: "CoveredPut",
            },
            {
                value: "NakedCall",
                label: "NakedCall",
            },
            {
                value: "NakedPut",
                label: "NakedPut",
            },
            {
                value: "Another",
                label: "Another",
            },
        ];

    const total = (
        dialogState.values.quantity * dialogState.values.open_price * 100
    ).toFixed(2);

    return (
        <div>
            <button type="button" className="btn btn-primary" onClick={handleClickOpen}>
                <Translate value="new" />
            </button>
            {open && (
                <div className="dialog" role="presentation" onClick={handleClose}>
                    <div
                        className="dialog-content dialog-content--entry-wide"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="entry-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="dialog-title" id="entry-modal-title">Option Entry</h2>
                        <p className="dialog-content-text">Enter option contract details</p>

                        <div className="entry-form">
                            <div className="entry-form-grid entry-form-grid--3">
                                <div className="symbol-search-wrap">
                                    <div className="entry-field">
                                        <label htmlFor="option-symbol">Symbol</label>
                                        <input
                                            autoFocus
                                            id="option-symbol"
                                            name="symbol"
                                            type="text"
                                            required
                                            onChange={handleChangeSymbol}
                                            autoComplete="off"
                                            value={(dialogState.values.symbol || '').toUpperCase()}
                                        />
                                    </div>
                                    {dialogState.values.symbol.length > 0 && !dialogState.values.name && (
                                        <ListStockSelect
                                            list={props.list}
                                            loading={props.loading}
                                            onClickSelected={onClickSelected}
                                        />
                                    )}
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-name">Company</label>
                                    <input
                                        id="option-name"
                                        name="name"
                                        type="text"
                                        disabled
                                        value={dialogState.values.name}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-reference">Strategy</label>
                                    <select
                                        id="option-reference"
                                        name="reference"
                                        value={dialogState.values.reference}
                                        onChange={handleChangeStrategy}
                                    >
                                        <option value="">Select strategy</option>
                                        {option_strategy.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <hr className="entry-form-divider" />

                            <div className="entry-form-grid entry-form-grid--3">
                                <div className="entry-field">
                                    <label htmlFor="option-quantity">Contracts</label>
                                    <input
                                        id="option-quantity"
                                        name="quantity"
                                        type="number"
                                        min="1"
                                        required
                                        value={dialogState.values.quantity}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-market">Side</label>
                                    <select
                                        id="option-market"
                                        name="market"
                                        required
                                        value={dialogState.values.market}
                                        onChange={handleChange}
                                    >
                                        <option value="">STO / BTO</option>
                                        {option_market.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-kind">Type</label>
                                    <select
                                        id="option-kind"
                                        name="option_kind"
                                        required
                                        value={dialogState.values.option_kind}
                                        onChange={handleChange}
                                    >
                                        <option value="">Call / Put</option>
                                        {option_kind.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-strike">Strike</label>
                                    <input
                                        id="option-strike"
                                        name="strike"
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        required
                                        value={dialogState.values.strike}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-price">Premiun/Debit</label>
                                    <input
                                        id="option-price"
                                        name="open_price"
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        required
                                        value={dialogState.values.open_price}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="option-expire">Expiration</label>
                                    <InputDate
                                        id="option-expire"
                                        name="expire_at"
                                        required
                                        label=""
                                        value={dialogState.values.expire_at}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="entry-field">
                                <label htmlFor="option-open_at">Open date</label>
                                <InputDate
                                    id="option-open_at"
                                    name="open_at"
                                    required
                                    label=""
                                    value={dialogState.values.open_at}
                                    onChange={handleChange}
                                    min="1900-01-01"
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>

                            <div className="entry-form-total">$ {total} USD (notional)</div>

                            <div className="dialog-actions">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    <Translate value="cancel" />
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!dialogState.isValid}
                                    onClick={handleSaveShare}
                                >
                                    <Translate value="save_share" />
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!dialogState.isValid}
                                    onClick={handleSave}
                                >
                                    <Translate value="save" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.stock.list,
        error: reducer.stock.error,
        loading: reducer.stock.loading,
    };
}
const mapDispatchToProps = dispatch => ({
    newItem: (params, token) =>
        dispatch(actions.newItem({ params, token })),
    loadList: (user_id, token) =>
        dispatch(actions.loadList({ user_id, token })),
    /////////
    searchList: (params, token) =>
        dispatch(actions_stock.searchList({ params, token })),
    resetList: () =>
        dispatch(actions_stock.resetList({})),
    ///////////////
    suscribeOption: (data) =>
        dispatch(actions_event.suscribeOption(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
